// extracted by mini-css-extract-plugin
module.exports = {"content":"src-TaskWindow-content-3b049a17","contentTopGradient":"src-TaskWindow-contentTopGradient-09b6b79c","close":"src-TaskWindow-close-95dd58f9"};